export enum BusinessType {
  Agency = "agency",
  DirectApp = "directApp",
}
